import React from "react";

export const RPGGameStoreEnergyIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.00016 1.66667H3.66683C3.76683 1.66667 3.8335 1.6 3.8335 1.5V1H6.16683V1.5C6.16683 1.6 6.2335 1.66667 6.3335 1.66667H7.00016C7.10016 1.66667 7.16683 1.6 7.16683 1.5V1C7.16683 0.45 6.71683 0 6.16683 0H3.8335C3.2835 0 2.8335 0.45 2.8335 1V1.5C2.8335 1.6 2.90016 1.66667 3.00016 1.66667Z"
        
      />
      <path
        d="M9 2.66675H1C0.45 2.66675 0 3.11675 0 3.66675V9.00008C0 9.55008 0.45 10.0001 1 10.0001H9C9.55 10.0001 10 9.55008 10 9.00008V3.66675C10 3.11675 9.55 2.66675 9 2.66675ZM6.41667 6.35008L4.66667 8.45008C4.56667 8.55008 4.4 8.46675 4.43333 8.33341L4.86667 6.83341H3.71667C3.58333 6.83341 3.48333 6.70008 3.53333 6.56675L4.23333 4.76675C4.3 4.61675 4.43333 4.51675 4.6 4.51675H5.73333H5.98333C6.13333 4.51675 6.23333 4.66675 6.15 4.80008L5.4 6.00008H6.26667C6.43333 6.00008 6.53333 6.21675 6.41667 6.35008Z"
        
      />
    </svg>
  );
};

